var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.79 2.125c-2.757 0-5 2.243-5 5v3h-1a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1v-3c0-2.757-2.243-5-5-5zm-3 5c0-1.654 1.346-3 3-3s3 1.346 3 3v3h-6v-3zm4 10.723v2.277h-2v-2.277a1.993 1.993 0 0 1 .567-3.677 2.001 2.001 0 0 1 2.433 1.954 1.99 1.99 0 0 1-1 1.723z",
    fill: "#8199B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputLockIcon);
export default __webpack_public_path__ + "static/media/Input-Lock-Icon.c3c254dc19a901e3d1e71eb490222f98.svg";
export { ForwardRef as ReactComponent };